var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.voltage)?_c('Icon',{attrs:{"icon-name":"battery","width":"30","height":"30","fill":_vm.currentCardDesign === 2 ? 'white' : '#B9B9BA',"title":_vm.tooltipText,"data-toggle":"tooltip","data-placement":"top"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }